<template>
  <el-row v-if="userCard" v-loading="loadingUser" :gutter="24">

    <el-col :xs="24">
      <div class="card">
<!--        <div class="card__balance">{{ user.balance }} H₵</div>-->
<!--        <div class="card__date">Состояние счета на  {{ currentDate  }}</div>-->
<!--        <div class="card__title">Выбор действия с бонусами</div>-->

        <el-radio-group
            class="tab-tags"
            v-model="currentTab"
            size="mini"
        >
          <el-radio-button
              v-for="tag in loyaltyTags"
              :key="tag.id"
              :label="tag.id"
          >{{ tag.title }}
          </el-radio-button>
        </el-radio-group>

        <el-tabs v-model="currentTab">
          <el-tab-pane label="User" name="decrease" class="tab-item">
            <div class="card__title">Списание бонусов клиента</div>
            <div class="card__subtitle">Выберите действие, выполненное клиентом для списания ему бонусов. Бонусы
              начислятся автоматически, соответственно со списком из правил работы с бонусами.
            </div>
            <edit-loyalty @reloadHistory="loadHistory" :typeItem="currentTab" :user="currentUser" :options="optionsList"/>
          </el-tab-pane>
          <el-tab-pane label="Config" name="increase" class="tab-item">
            <div class="card__title">Начисление бонусов</div>
            <div class="card__subtitle">Выберите действие, выполненное клиентом для начисления ему бонусов. Бонусы
              отобразятся автоматически, соответственно со списком из правил работы с бонусами.
            </div>
            <edit-loyalty  @reloadHistory="loadHistory" :typeItem="currentTab" :user="currentUser" :options="optionsList"/>
          </el-tab-pane>
          <el-tab-pane label="Config" name="history" class="tab-item">
            <div class="card__title">История начисления и списания бонусов клиента</div>
            <div class="card__subtitle">
            </div>
          </el-tab-pane>

          <el-tab-pane label="Config" name="rules" class="tab-item">
            <div class="card__title">Начисление бонусов</div>
            <div class="card__subtitle">Бонусы начисляются клиенту за активности внутри приложения, прохождение
              процедур. В большинстве случаев бонусы начисляются автоматически, но некоторые виды бонусов начисляются
              оператором и требуют фиксации с его стороны.
            </div>
            <rules-table :options="optionsList" type="increase"/>
            <div class="card__description card__description_red">* Фиксируется оператором</div>
            <div class="card__title">Списание бонусов</div>
            <div class="card__subtitle">Бонусы клиентов списываются исключительно оператором. Списание происходит в
              счет оплаты услуг, услуга может быть погашена полностью за счёт бонусов, если их достаточно.
            </div>
            <rules-table :options="optionsList" type="decrease"/>
            <div class="card__description">Списание и начисление бонусов можно произвести на вкладках “Списание” и  “Начисление” соответственно</div>
          </el-tab-pane>
        </el-tabs>

        <history-table v-show="isShowHistory" ref="history" :typeItem="currentTab" :user="currentUser"></history-table>
      </div>
    </el-col>
  </el-row>

</template>

<script>
import HistoryTable from "@/components/elements/UserSettingsPanel/HistoryTable.vue"
import EditLoyalty from "@/components/elements/UserSettingsPanel/EditLoyalty.vue"
import RulesTable from "@/components/elements/UserSettingsPanel/RulesTable.vue"

export default {
  name: "UserLoyalty",
  data() {
    return {
      loadingUser: true,
      userCard: {},
      currentUser: this.user,
      currentTab: "decrease",
      loyaltyHistory: [],
      optionsList: [],
      reload: false,
      loyaltyTags: [
        {
          id: "decrease",
          title: "Списание",
        },
        {
          id: "increase",
          title: "Начисление",
        },
        {
          id: "history",
          title: "История",
        },
        {
          id: "rules",
          title: "Правила работы с бонусами",
        }
      ],
    }
  },
  components: {
    HistoryTable,
    EditLoyalty,
    RulesTable
  },
  props: {
    user: {
      required: true
    }
  },
  mounted() {
    this.getLoyaltyHistory();

  },
  computed: {
    isShowHistory() {
      return this.reload || this.currentTab === "rules" ? false : true
    },
    currentDate() {
      return this.$root.dateDefault(new Date())
    }
  },
  methods: {
    saveUserCard() {

      this.loadingUser = true;
      this.$api.loyalty.history(this.currentUser.id)
          .then(() => {

            this.$notify.success({
              title: "Удачно...",
              message: "Запись изменена",
            })

          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка изменения 😕",
              message: response.response.data.message,
            });

          })
          .finally(() => {
            this.loadingUser = false;
          });
    },
    getLoyaltyHistory() {
      this.loadingUser = true;
      this.$api.loyalty.list()
          .then((response) => {
            this.optionsList = response.data
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки истории лояльности 😕",
              message: response.response.data.message,
            });

          })
          .finally(() => {
            this.loadingUser = false;
          });
    },
    loadHistory () {
      this.$emit('reloadDataUser')
      this.$refs.history.loadLogic()

    }
  }
}

</script>

<style lang="scss" scoped>
.card {

  &__balance {
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 41px;

    color: #111;
  }

  &__date {

    margin: 2px 0 24px 0;

    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;

    color: #8E8E93;
  }

  &__title {
    margin-top: 32px;

    font-weight: 600;
    font-size: 20px;
    line-height: 26px;
    color: #111111;
  }

  &__subtitle {
    margin-top: 8px;
    font-style: normal;
    font-weight: normal;

    font-size: 15px;
    line-height: 20px;


    color: #8E8E93;
  }

  &__description {
    margin-top: 5px;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;

    color: #111;

    &_red {
      color: #FF6464;
    }
  }

}

.tab-tags {
  margin-top: 8px;
}

.tab-item {
  margin-top: 16px;

}

/deep/ .el-tabs__header {
  display: none;
}

</style>
